import React, { Component } from 'react';
import classNames from 'classnames';
import { KeyCode } from '../../../library/constants/KeyCode';

export class SearchInputBox extends Component {
    constructor(props) {
        super(props);
        let {
            defaultValue = '',
            disabled = false,
            placeholder = '',
            inputStyles = {},
            isShowSearchIcon = true,
            fieldsetStyles = {},
            type = 'text',
            title = '검색어 입력',
            maxLength,
            xButtonStyle = isShowSearchIcon ? {} : { right: 30 },
        } = this.props;

        this.state = {
            searchWord: defaultValue,
            isRefreshButtonShow: false,
            disabled: disabled,
            placeholder: placeholder,
            inputStyles: inputStyles,
            fieldsetStyles: fieldsetStyles,
            isShowSearchIcon,
            type,
            title,
            xButtonStyle,
            maxLength,
        };
        this.onChangeWord = this.onChangeWord.bind(this);
        this.onRefresh = this.onRefresh.bind(this);
        this.searchInputBoxTrigger = this.searchInputBoxTrigger.bind(this);
        this.onSearchIconClick = this.onSearchIconClick.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    onChangeWord(e) {
        this.setState({
            searchWord: e.target.value,
        });
        if (this.props.onChange) {
            this.props.onChange(e, e.target.value);
        }
    }

    onRefresh() {
        this.setState(
            {
                searchWord: '',
            },
            () => {
                if (this.props.onChange) {
                    this.props.onChange(null, this.state.searchWord);
                }
            }
        );
    }

    searchInputBoxTrigger(e) {
        if (this.props.onChange) {
            this.props.onChange(e, this.state.searchWord);
        }
    }

    onSearchIconClick(e) {
        let { onSearchIconClick, onChange } = this.props;
        if (onSearchIconClick) {
            this.props.onSearchIconClick(e, this.state.searchWord);
        } else if (onChange) {
            this.props.onChange(e, this.state.searchWord);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.disabled !== nextProps.disabled) {
            this.setState({
                disabled: nextProps.disabled,
            });
        }
        if (this.props.inputStyles !== nextProps.inputStyles) {
            this.setState({
                inputStyles: nextProps.inputStyles,
            });
        }
        if (this.props.value !== nextProps.value) {
            this.setState({
                searchWord: nextProps.value,
            });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.setTimer);
    }

    onBlur(e) {
        this.setTimer = setTimeout(() => {
            this.setState({ isRefreshButtonShow: false });
        }, 300);
        if (this.props.onBlur) {
            this.props.onBlur(e);
        }
    }

    onKeyDown(e) {
        if (e.keyCode === KeyCode.ENTER) {
            if (this.props.onKeyDown) {
                return this.props.onKeyDown(e);
            }
            this.searchInputBoxTrigger(e);
        }
    }

    render() {
        let {
            searchWord,
            disabled,
            placeholder,
            inputStyles,
            isShowSearchIcon,
            type,
            title,
            maxLength,
        } = this.state;
        return (
            <fieldset>
                <legend>검색</legend>
                <input
                    type={type}
                    style={inputStyles}
                    className={classNames('on', { disabled: disabled })}
                    disabled={disabled}
                    value={searchWord}
                    title={title}
                    placeholder={placeholder}
                    onChange={this.onChangeWord}
                    onFocus={() => {
                        this.setState({ isRefreshButtonShow: true });
                    }}
                    maxLength={maxLength}
                    onBlur={this.onBlur}
                    onKeyDown={this.onKeyDown}
                    ref={(ref) => {
                        if (this.props.inputRef) {
                            this.props.inputRef(ref);
                        }
                    }}
                />

                {isShowSearchIcon && !disabled && (
                    <button
                        className="btn-type3"
                        onClick={(e) => {
                            this.onSearchIconClick(e);
                        }}
                    >
                        검색
                    </button>
                )}
            </fieldset>
        );
    }
}
